import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from "../reducers/user-profiles";

export const selectUserProfileState = createFeatureSelector<State>('userProfiles');

export const getAllUserProfiles = createSelector(
  [selectUserProfileState],
  (userProfilesState: State) => {
    return userProfilesState.userProfiles;
  }
);

export const selectUserProfilesLoading = createSelector(
  [selectUserProfileState],
  (state: State) => {
    return state.loading;
  }
);
